import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { cn } from "@/lib/utils";
import { useNav } from "@/utils/nav";
import { Link, Outlet, createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/forms/pages")({
    component: FormPagesLayout,
});

const FORM_PAGE_SCREENS = [
    { screen: "cover", label: "Cover", description: "The public start page, before the first question." },
    { screen: "instructions", label: "Instructions", description: "Instructions on their own screen, before page 1." },
    { screen: "question", label: "Question", description: "A page with a question, as the patient answers it." },
    { screen: "block", label: "Block", description: "A page of text, images or video with no questions." },
] as const;

function FormPagesLayout() {
    const { screen } = useParams({ strict: false }) as { screen?: string };
    const current = FORM_PAGE_SCREENS.find((item) => item.screen === screen);
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Forms", route: { to: "/design/forms" } },
        { label: "Pages", route: { to: "/design/forms/pages" } },
    ]);

    return (
        <AdminPageLayout
            title="Form pages"
            description={current?.description ?? "Each screen a patient sees, with every variable named."}
            maxWidthClassName="max-w-5xl"
        >
            <div className="space-y-6">
                <nav aria-label="Form screens" className="flex flex-wrap gap-2">
                    {FORM_PAGE_SCREENS.map((item) => (
                        <Link
                            key={item.screen}
                            to="/design/forms/pages/$screen"
                            params={{ screen: item.screen }}
                            className={cn(
                                "px-4 py-1.5 border rounded-full font-medium text-sm transition-colors",
                                item.screen === screen
                                    ? "bg-sky-600 border-sky-600 text-white"
                                    : "bg-white border-slate-300 text-slate-700 hover:border-sky-400"
                            )}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>
                <Outlet />
            </div>
        </AdminPageLayout>
    );
}
